export default __webpack_public_path__ + "static/media/Saumyajit2.c2a5847b.jpg";